import React, { useState } from "react";
import { useHistory, useLocation } from "react-router";
import styled from "styled-components";
import Layout from "../components/Layout";
import { C, F, ring, Button, Container } from "../styles";
import { registrarInscricao } from "../../sos_lp/inscricao";
import { login } from "../service";
import { safeNext } from "../utils/status";

const Card = styled.form`
  width: 100%;
  max-width: 440px;
  margin: clamp(8px, 4vw, 40px) auto;
  border-radius: 20px;
  background: ${C.blue};
  box-shadow: ${ring(1.5, C.yellow)}, 0 30px 60px -20px rgba(0, 0, 0, 0.6);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.h1`
  margin: 0;
  font: 700 24px/1.15 ${F.title};
  letter-spacing: -0.03em;
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

const Close = styled.button`
  background: none;
  border: none;
  color: ${C.white};
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
`;

const Text = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
`;

const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font: 600 13px/1 ${F.title};
`;

const Input = styled.input`
  font: 500 15px ${F.body};
  padding: 14px 16px;
  border-radius: 12px;
  border: none;
  background: ${C.navy};
  color: ${C.white};
  box-shadow: ${(p) => ring(p.invalid ? 1.5 : 1, p.invalid ? C.orange : "rgba(255,255,255,0.18)")};
  outline: none;
  &:focus {
    box-shadow: ${ring(1.5, C.yellow)};
  }
`;

const Error = styled.span`
  font: 600 13px/1.4 ${F.title};
  color: ${C.yellow};
`;

const SignUp = styled.a`
  font: 700 14px/1.4 ${F.title};
  color: ${C.white};
  text-decoration: underline;
  &:hover {
    color: ${C.yellow};
  }
`;

const maskPhone = (value) => {
  const d = value.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function LoginPage() {
  const history = useHistory();
  const location = useLocation();
  const next = safeNext(new URLSearchParams(location.search).get("next"));
  const toLive = next.startsWith("/ao-vivo");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const emailOk = EMAIL_RE.test(email.trim());
  const phoneOk = phone.replace(/\D/g, "").length >= 10;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!emailOk || !phoneOk) {
      setError(!emailOk ? "Confira o seu e-mail." : "Confira o seu WhatsApp com DDD.");
      return;
    }
    setBusy(true);
    setError(null);
    const res = await login({ email, whatsapp: phone });
    if (!res.ok) {
      setBusy(false);
      setError(res.error);
      return;
    }
    // Igual ao Craques do Enem: entrar também registra o lead (/leads e /dashboard/lp).
    await registrarInscricao({ nome: res.user.name, email, whatsapp: phone });
    // Recarrega para todas as telas lerem a sessão nova.
    window.location.assign(next);
  };

  return (
    <Layout title="Simulados" action="none">
      <Container>
        <Card onSubmit={onSubmit} noValidate>
          <TitleRow>
            <Title>Entre com a sua inscrição</Title>
            <Close type="button" aria-label="Fechar" onClick={() => history.push(toLive ? "/ao-vivo" : "/simulados")}>
              ✕
            </Close>
          </TitleRow>
          <Text>
            Confirme seus dados pra {toLive ? "baixar os materiais" : "entrar no simulado"} do SOS. É o mesmo acesso da sua inscrição no evento.
          </Text>
          <Label>
            E-mail
            <Input
              type="email"
              autoComplete="email"
              placeholder="voce@email.com"
              value={email}
              invalid={error && !emailOk}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Label>
          <Label>
            WhatsApp
            <Input
              type="tel"
              autoComplete="tel-national"
              inputMode="numeric"
              placeholder="(00) 00000-0000"
              value={phone}
              invalid={error && emailOk && !phoneOk}
              onChange={(e) => setPhone(maskPhone(e.target.value))}
            />
          </Label>
          {error && <Error role="alert">{error}</Error>}
          {error && error.startsWith("Não encontramos") && (
            <SignUp href="/#inscricao">Ainda não se inscreveu? Faça a inscrição grátis →</SignUp>
          )}
          <Button type="submit" variant="orange" block size={16} pad="16px" disabled={busy} style={{ marginTop: 4 }}>
            {toLive ? "ENTRAR →" : "ENTRAR NO SIMULADO →"}
          </Button>
        </Card>
      </Container>
    </Layout>
  );
}
